import { render, staticRenderFns } from "./TheHeaderDropdownMssgs.vue?vue&type=template&id=aa0fe1a4&scoped=true&"
import script from "./TheHeaderDropdownMssgs.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownMssgs.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownMssgs.vue?vue&type=style&index=0&id=aa0fe1a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0fe1a4",
  null
  
)

export default component.exports